import { realtimeEntityToStoreName, storeNameToRealtimeEntity } from '@persistence/persist-registry';

/**
 * Facade over the persist registry: the entity <-> store mapping is no longer a literal map here —
 * each store declares its own protocol name via @PersistedStoreConfig({ realtimeEntity }). The two
 * functions keep the historical names (and the identity fallback, part of the protocol contract)
 * so the sync/runtime consumers don't churn.
 */
export function toRealtimeV2StoreName(entityName: string): string {
  return realtimeEntityToStoreName(entityName);
}

export function toRealtimeV2EntityName(storeName: string): string {
  return storeNameToRealtimeEntity(storeName);
}
